import { render, staticRenderFns } from "./CatalogHeader.vue?vue&type=template&id=1bc447f0"
import script from "./CatalogHeader.vue?vue&type=script&lang=ts"
export * from "./CatalogHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports